import React, { useState } from 'react';
import SoundManager from '../../utils/SoundManager';
import './PowerUpBar.css';

const PowerUpBar = ({ 
  onThothPower, 
  onAnansiPower, 
  onGrioPower,
  thothCooldown,
  anansiCooldown,
  grioCooldown
}) => {
  const powers = [
    {
      id: 'thoth',
      name: 'Sabedoria de Thoth',
      description: 'Revela um par errado',
      icon: '📜',
      color: '#9c27b0',
      cooldown: thothCooldown,
      onActivate: onThothPower
    },
    {
      id: 'anansi',
      name: 'Ritmo de Anansi',
      description: 'Pausa o tempo por 10s',
      icon: '🕷️',
      color: '#ff6b35',
      cooldown: anansiCooldown,
      onActivate: onAnansiPower
    },
    {
      id: 'grio',
      name: 'Memória de Griô',
      description: 'Mostra todas as cartas por 1.5s',
      icon: '✨',
      color: '#ffd700',
      cooldown: grioCooldown,
      onActivate: onGrioPower
    }
  ];

  const [showTooltip, setShowTooltip] = useState(null);

  // Mapeamento de sons por poder
  const powerSounds = {
    thoth: 'power-thoth',
    anansi: 'power-anansi',
    grio: 'power-grio'
  };

  const handlePowerClick = (power) => {
    if (power.cooldown === 0) {
      // Tocar som específico do poder
      const soundName = powerSounds[power.id];
      if (soundName) {
        SoundManager.play(soundName);
      }
      
      power.onActivate();
    }
  };

  return (
    <div className="power-up-bar">
      <div className="power-up-title">PODERES ANCESTRAIS</div>
      <div className="powers-container">
        {powers.map((power) => {
          const isReady = power.cooldown === 0;
          const progress = isReady ? 100 : ((30 - power.cooldown) / 30) * 100;

          return (
            <div
              key={power.id}
              className={`power-item ${isReady ? 'ready' : 'cooldown'}`}
              onClick={() => handlePowerClick(power)}
              onMouseEnter={() => setShowTooltip(power.id)}
              onMouseLeave={() => setShowTooltip(null)}
              onTouchStart={() => setShowTooltip(power.id)}
              onTouchEnd={() => setTimeout(() => setShowTooltip(null), 2000)}
            >
              <div className="power-icon-wrapper">
                <span className="power-icon">{power.icon}</span>
                {!isReady && (
                  <div className="cooldown-overlay">
                    <div 
                      className="cooldown-fill" 
                      style={{ 
                        height: `${progress}%`,
                        background: power.color
                      }}
                    ></div>
                  </div>
                )}
              </div>

              {!isReady && (
                <div className="cooldown-text">{power.cooldown}s</div>
              )}

              {showTooltip === power.id && (
                <div className="power-tooltip">
                  <div className="tooltip-title">{power.name}</div>
                  <div className="tooltip-desc">{power.description}</div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PowerUpBar;
